import React, { useEffect, useState } from "react";
import TopNavbar from "../../shares/TopNavbar";

export default function Fora() {
  const [error, setError] = useState("");

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const ctx = query.get("ctx");

    if (ctx) {
      const target = `/Account?ctx=${encodeURIComponent(ctx)}`;
      window.location.replace(target);
      return;
    }

    setError("Invalid or expired link. Please request a new connection link from Fora.");
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100">
      <TopNavbar />
      <main className="mx-auto max-w-xl px-4 py-14">
        <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
          {error ? (
            <>
              <h1 className="text-xl font-semibold text-slate-900">Unable to continue</h1>
              <p className="mt-2 text-sm text-slate-700">{error}</p>
            </>
          ) : (
            <>
              <h1 className="text-xl font-semibold text-slate-900">Verifying secure link</h1>
              <p className="mt-2 text-sm text-slate-700">Please wait while we initialize your connector session.</p>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
